import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "faqs"
    }}>{`FAQs`}</h1>
    <br></br>
    <h3 {...{
      "id": "how-is-the-uxp-sdk-different-from-the-photoshop-c-sdk-aka-csdk"
    }}>{`How is the UXP SDK different from the Photoshop C++ SDK (aka CSDK)?`}</h3>
    <p>{`The two SDKs serve different purposes. The new UXP SDK lets you write any generic C++ code alongside JavaScript. The PS C++ SDK helps you extend Photoshop capabilities in seven areas including filters, file formats, and selections.`}</p>
    <p>{`Before the introduction of UXP hybrid plugins, there were a few examples of third-party developers pairing a PS C++ plugin to a UXP plugin for UI. However, there are some challenges with that approach:`}</p>
    <ol>
      <li parentName="ol">{`Such plug-ins require a custom installer that installs the two separate plugins on the user’s machine (one for UXP and the other for the C++ plug-in).`}</li>
      <li parentName="ol">{`Communication between the two plugins is only possible in strings.`}</li>
    </ol>
    <p>{`The hybrid plugin you build using the new UXP SDK will let you bundle C++ code and JavaScript in the same plugin package and provide you with more efficient options to communicate between the two worlds.`}</p>
    <br></br>
    <h3 {...{
      "id": "can-i-build-a-photoshop-filter-or-other-such-capabilities-with-the-new-hybrid-plugin-sdk"
    }}>{`Can I build a Photoshop filter (or other such capabilities) with the new Hybrid plugin SDK?`}</h3>
    <p>{`Yes, see the section under `}<a parentName="p" {...{
        "href": "../getting-started/#photoshop-c-sdk"
      }}>{`Getting started`}</a>{`.`}</p>
    <br></br>
    <h3 {...{
      "id": "do-i-need-to-code-sign-the-entire-plugin-bundle"
    }}>{`Do I need to code sign the entire plugin bundle?`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "92.1875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/76908ad7254e2f6d9e8f1c772bf2fdaf/5530d/folder-structure.webp 320w", "/photoshop/uxp/2022/static/76908ad7254e2f6d9e8f1c772bf2fdaf/0c8fb/folder-structure.webp 640w", "/photoshop/uxp/2022/static/76908ad7254e2f6d9e8f1c772bf2fdaf/cf465/folder-structure.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/76908ad7254e2f6d9e8f1c772bf2fdaf/dd4a7/folder-structure.png 320w", "/photoshop/uxp/2022/static/76908ad7254e2f6d9e8f1c772bf2fdaf/0f09e/folder-structure.png 640w", "/photoshop/uxp/2022/static/76908ad7254e2f6d9e8f1c772bf2fdaf/78d47/folder-structure.png 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/76908ad7254e2f6d9e8f1c772bf2fdaf/78d47/folder-structure.png",
            "alt": "Folder Structure",
            "title": "Folder structure",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`No. You only need to sign (and notarize) the macOS executables with a valid Apple Developer certificate.`}</p>
    <br></br>
    <h3 {...{
      "id": "do-i-need-an-apple-developer-id-to-signnotarize-the-executables-in-hybrid-plugins"
    }}>{`Do I need an Apple Developer ID to sign/notarize the executables in hybrid plugins?`}</h3>
    <p>{`Yes. macOS only recognizes Developer ID-signed certificates (signed with your Apple Developer ID). Find the details in `}<a parentName="p" {...{
        "href": "https://support.apple.com/guide/security/app-code-signing-process-sec3ad8e6e53/web"
      }}>{`Apple's guide`}</a>{`.`}</p>
    <br></br>
    <h3 {...{
      "id": "how-can-i-prepare-the-binaries"
    }}>{`How can I prepare the binaries?`}</h3>
    <p>{`You need to prepare binaries for all three architectures: Mac M1, Mac Intel, and Windows Intel.`}</p>
    <p>{`For the Operating System that is not available to you natively, you can use a virtual machine, such as VMware Fusion, to compile and test your plugin.`}</p>
    <p>{`For creating binaries that work for both — Mac Intel and M1 architectures, refer to `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/apple-silicon/building-a-universal-macos-binary"
      }}>{`Apple's guide for some tips`}</a>{` for some tips.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      